import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import clsx from 'clsx'

export function EmptyLayout() {
	return (
		<div>
			<Helmet
				bodyAttributes={{
					class: clsx('bg-theme-surface'),
				}}
			/>
			<main className="pb-4">
				{/* Start main area*/}
				<Outlet />
				{/* End main area */}
			</main>
		</div>
	)
}
